import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui";
import { SectionCard } from "@/components/common";
import { MediaCarousel } from "../../components/MediaCarousel/index";
import type { MediaItem } from "@/types";

interface MediaSectionProps {
  media: MediaItem[];
  activityId: string;
  onChange: (media: MediaItem[]) => void;
  onAutoSave: (media: MediaItem[]) => Promise<void>;
}

export function MediaSection({
  media,
  activityId,
  onChange,
  onAutoSave,
}: MediaSectionProps) {
  const { t } = useTranslation("activities");

  return (
    <SectionCard
      title={t("media.sectionTitle")}
      badge={
        <Badge
          variant="success"
          size="sm"
        >
          {t("media.autoSaveBadge")}
        </Badge>
      }
      description={t("media.sectionDescription")}
      className="mb-6"
    >
      <MediaCarousel
        media={media}
        onChange={onChange}
        onAutoSave={onAutoSave}
        activityId={activityId}
        editable
      />
    </SectionCard>
  );
}
